import axios from 'axios';
import { useService } from '../common/useService';
import { OrderFileType } from '../files/order-file-type.type';
import { RemoteFile } from '../files';

export type UploadPhotosDictionary = { [key: string]: { finalPhoto: File; photoType: OrderFileType } };
export type UploadPhotosParams = { data: UploadPhotosDictionary; userId: number };

const useUploadPhotos = () => {
  return useService((params: UploadPhotosParams) => {
    const formData = new FormData();
    const uploadedPhotosJson = JSON.stringify(params.data);

    Object.values(params.data).forEach((value, index) => {
      const filePhoto = value.finalPhoto;
      formData.append(`file[${index}]`, filePhoto);
    });

    formData.append('photoInfo', uploadedPhotosJson);
    formData.append('action', 'photos-uploaded');
    formData.append('userId', params.userId.toString());

    return axios.post(`/upload-photos/upload.php`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  });
};

const useGetPhotos = () => {
  return useService((userId: number) => {
    const url = new URL('/my-account-api/user/photos.php', window.location.origin);
    url.searchParams.append('userId', userId.toString());
    return axios.get<RemoteFile[]>(url.href);
  });
};

const PhotoService = {
  useUploadPhotos,
  useGetPhotos,
};
export default PhotoService;
